import { render, staticRenderFns } from "./cbdoil.vue?vue&type=template&id=52f7a0cb&scoped=true&"
import script from "./cbdoil.vue?vue&type=script&lang=js&"
export * from "./cbdoil.vue?vue&type=script&lang=js&"
import style0 from "./cbdoil.vue?vue&type=style&index=0&id=52f7a0cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7a0cb",
  null
  
)

export default component.exports